function filterProp(){
    jQuery(function($){
        
        var delayTimer;
        $(document).on('input','#filter',function(){
            var filter = $(this);
            clearTimeout(delayTimer);
            delayTimer = setTimeout(function() {
                $.ajax({
                    url:filter.attr('action'), 
                    data:filter.serialize(), 
                    type:filter.attr('method'), 
                    dataType : "json",
                    beforeSend:function(xhr){ 
                    },
                    success:function(data){
                        $('#response').html(data['out']);
                        lazyLoadInstance.update();
                        popUp();
                        console.log('qwe');
                    }
                });
            }, 1000);
            return false;
        });
    });
}
module.exports = filterProp;